import { Card } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Plus } from 'lucide-react';
import { useBanners } from './hooks/useBanners';
import { BannersTable, BannerDialog } from './components';
import { ErrorState, PageHeader, Toolbar } from '@/components/app';

export default function BannersPage() {
  const {
    banners,
    isLoading,
    loadError,
    retryLoad,
    isCreateDialogOpen,
    isEditDialogOpen,
    editingBanner,
    formData,
    isSubmitting,
    errors,
    clearFieldError,
    setIsCreateDialogOpen,
    setIsEditDialogOpen,
    setFormData,
    openCreateDialog,
    handleCreate,
    handleEdit,
    handleUpdate,
    handleDelete,
    handleToggleActive,
  } = useBanners();

  const activeCount = banners.filter((b) => b.is_active).length;

  return (
    <div className="flex flex-col gap-5">
      <PageHeader
        title="Баннеры"
        subtitle="Промо-блок на главном экране приложения. Одновременно показывается один — с наибольшим приоритетом среди подходящих"
        actions={
          <Button onClick={openCreateDialog}>
            <Plus aria-hidden />
            Создать баннер
          </Button>
        }
      />

      <Card className="overflow-hidden">
        {loadError ? (
          <ErrorState message={loadError} onRetry={retryLoad} />
        ) : (
          <>
            <Toolbar
              title={isLoading ? 'Загрузка…' : `Баннеров: ${banners.length}`}
              end={!isLoading && banners.length > 0 ? <span>Включено: {activeCount}</span> : undefined}
            />
            <BannersTable
              banners={banners}
              isLoading={isLoading}
              selectedId={isEditDialogOpen ? editingBanner?.id ?? null : null}
              onEdit={handleEdit}
              onDelete={handleDelete}
              onToggleActive={handleToggleActive}
              onCreate={openCreateDialog}
            />
          </>
        )}
      </Card>

      <BannerDialog
        isOpen={isCreateDialogOpen}
        onOpenChange={setIsCreateDialogOpen}
        formData={formData}
        onFormDataChange={setFormData}
        onSubmit={handleCreate}
        isSubmitting={isSubmitting}
        errors={errors}
        onClearFieldError={clearFieldError}
        title="Создать баннер"
        description="Появится на главном экране приложения"
        submitLabel="Создать"
      />

      <BannerDialog
        isOpen={isEditDialogOpen}
        onOpenChange={setIsEditDialogOpen}
        formData={formData}
        onFormDataChange={setFormData}
        onSubmit={handleUpdate}
        isSubmitting={isSubmitting}
        errors={errors}
        onClearFieldError={clearFieldError}
        title="Редактировать баннер"
        description="Изменения увидят пользователи при следующем открытии главного экрана"
        submitLabel="Сохранить"
      />
    </div>
  );
}
